<template>
    <div>
        <article class="weui-article">
            <section class="logo-section">
                <img class="logo" src="../../../static/image/wxlogo.png">
            </section>
            <section class="watchword">
                <h1>跑腿赚赏金</h1>
            </section>
            <section>
                <section>
                    <h3>1.1 送件上门赚赏金</h3>
                    <p>
                        校圆通每天都有大量快递到达站点，如果收件人没有时间或者嫌麻烦不想亲自到快递服务中心取件，那么TA可以在平台上发布一个代取的跑腿任务，成为校内跑腿后，您可以在待领取的跑腿任务列表中看到这些新发布出来的跑腿订单，接单后把快递送到任务发布者指定的地方并成功交付给对方后可以得到对应的赏金。
                    </p>
                </section>
                <section>
                    <h3>1.2 上门取件赚赏金（须开通上门取件资格）</h3>
                    <p>
                        校圆通每天也有很多用户有寄件需求，当这些用户没时间或者嫌麻烦不想亲自把待寄物品拿到快递服务中心的时候，TA们就会在平台上发布一个上门取件任务，成为校内跑腿后，您可以在待领取的跑腿任务列表中看到这些新发布出来的跑腿订单，接单后到任务发布至指定的地方取件并收取寄件费用，把待寄物品拿回快递服务中心后可以得到对应的赏金。
                    </p>
                </section>
            </section>
        </article>

        <div class="weui-footer">
            <p class="weui-footer__links">
                <a href="javascript:void(0);" class="weui-footer__link">校圆通</a>
            </p>
            <p class="weui-footer__text">Copyright &copy; 2017-{{year}} aixyt.com</p>
        </div>
    </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
        year: moment().format('YYYY')
    };
  }
};
</script>

<style scoped>
.logo-section {
    text-align: center;
    margin-top: 20px;
}
.logo {
    width: 50%;
  max-width: 120px;
}
.watchword {
    text-align: center;
}
.watchword h2 {
    font-weight: bold;
}
.weui-footer {
  margin-bottom: 20px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
</style>





// WEBPACK FOOTER //
// src/components/infos/PaotuiMakeMoney.vue